import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { PageResponseDTO } from "@/shared/types/pagination.types";
import type {
  CommissionPeriodParams,
  CommissionResponseDTO,
  CommissionSearchParams,
  CommissionSummaryDTO,
  CommissionUpsertRequestDTO,
} from "../types/commission.types";

export const commissionService = {
  search: async (
    params?: CommissionSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<CommissionResponseDTO>> => {
    const response = await api.get<PageResponseDTO<CommissionResponseDTO>>(
      API_ENDPOINTS.SELLER_COMMISSIONS.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  summary: async (
    params: CommissionPeriodParams,
    options?: RequestOptions,
  ): Promise<CommissionSummaryDTO[]> => {
    const response = await api.get<CommissionSummaryDTO[]>(
      API_ENDPOINTS.SELLER_COMMISSIONS.SUMMARY,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<CommissionResponseDTO> => {
    const response = await api.get<CommissionResponseDTO>(
      API_ENDPOINTS.SELLER_COMMISSIONS.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  create: async (
    data: CommissionUpsertRequestDTO,
  ): Promise<CommissionResponseDTO> => {
    const response = await api.post<CommissionResponseDTO>(
      API_ENDPOINTS.SELLER_COMMISSIONS.BASE,
      data,
    );
    return response.data;
  },

  update: async (
    id: number,
    data: CommissionUpsertRequestDTO,
  ): Promise<CommissionResponseDTO> => {
    const response = await api.put<CommissionResponseDTO>(
      API_ENDPOINTS.SELLER_COMMISSIONS.BY_ID(id),
      data,
    );
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.SELLER_COMMISSIONS.BY_ID(id));
  },
};
